/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  clearTaskModalStatuses,
  storeTaskModalStatus,
} from '../../../../../../../../app/task-modals/task-modals.actions';
import { taskModalSelectors } from '../../../../../../../../app/task-modals/task-modals.selectors';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { MembersMenu } from '../../TaskMenus/MembersMenu';
import { IMenuMembersProps } from './types';

export const MenuMembers: FunctionComponent<IMenuMembersProps> = ({ userIds, taskId }) => {
  const dispatch = useDispatch();
  const triggerRef = useRef<HTMLAnchorElement>(null);

  const open = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskMembers');

  const toggle = useCallback(() => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    } else {
      dispatch(storeTaskModalStatus('taskMembers'));
    }
  }, [dispatch, open]);

  return (
    <div className={open ? 'dropdown opened' : 'dropdown'}>
      <a
        className="btn w100 gray-bg darkGray px-1 f-1 ml-0 mb-1 mt-1 dropdown-button "
        onClick={toggle}
        ref={triggerRef}
      >
        <i className="icon f-9 blueGray icon-user mr-1" /> Members
      </a>
      {open && taskId && (
        <MembersMenu userIds={userIds} dropRight={true} closeMenu={toggle} taskId={taskId} triggerRef={triggerRef} />
      )}
    </div>
  );
};
